<template>
	<div class="separator separator--mobile separator--not-found-bg">
		<div class="page-wrapper">
			<div class="infobox infobox--not-found">
				<div class="infobox__col">
					<section class="section-wrapper section-wrapper--not-found">
						<h1>{{ $t('not_found.not_found_title') }}</h1>
						<span class="code-msg">404</span>
						<p>{{ $t('not_found.not_found_msg') }}</p>
						<router-link :to="$locale.toRouteLinkProp('home')" class="button">{{ $t('not_found.not_found_btn') }}</router-link>
					</section>
				</div>
				<div class="infobox__col">
					<img src="@/assets/pages/404/404_illustration.png" class="four-oh-img"/>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

export default {
	components: {  },

	mounted () {

	},

	data () {
		return {

		}
	},

	computed: {

	},

	methods: {

	}
}
</script>

<style scoped>
	.separator--not-found-bg {
		background: url('./../../assets/pages/404/404_image_fond.png');
		background-position: -1400px 0px;
		background-repeat: no-repeat;
		padding: 0px 50px;
	}

	@media (min-width: 1600px) {
		.separator--not-found-bg {
			background-position: -800px 0px;
		}
	}

	@media (min-width: 1920px) {
		.separator--not-found-bg {
			background-position: -1000px 0px;
		}
	}
	.infobox--not-found {
		background: none;
	}
	.section-wrapper--not-found {
		max-width: 345px;
		margin: 0;
	}
	.infobox--not-found h1 {
		color: #fff;
		font-weight: 700;
		font-size: 3em;
		margin-bottom: 10px;
	}
	.infobox--not-found p {
		color: #fff;
		font-size: 1.2em;
		line-height: 1.2em;
		margin-bottom: 50px;
	}
	.infobox--not-found .code-msg {
		display: inline-block;
		margin: 20px 0;
		color: #fff;
		font-weight: 300;
		font-size: 5em;
	}
	.infobox--not-found .button {
		font-size: .8em;
		white-space: normal;
	}
	.infobox--not-found .infobox__col {
		padding-top: 0;
		padding-bottom: 0;
		display: flex;
		align-items: center;
	}
	.infobox--not-found .infobox__col:last-child {
		align-items: start;
	}
	.four-oh-img {
		width: auto;
		max-width: 100%;
	}

	@media (max-width: 767px) {
			.infobox--not-found {
				-webkit-flex-wrap: wrap;
	  			flex-wrap: wrap;
	  			flex-direction: column;
			}
			.infobox--not-found .infobox__col:last-child {
				order: 1;

			}
			.infobox--not-found .infobox__col:first-child {
				order: 2;
				flex-basis: 100% !important;
			}
			.section-wrapper--not-found {
				padding: 20px 0;
			}
		}


	@media (max-width: 900px) {
		.infobox--not-found .infobox__col:last-child {
			right: auto;
			width: auto;
		}
		.infobox--not-found .infobox__col:first-child {
			flex-basis: 0;
		}
	}
</style>
